export default __webpack_public_path__ + "53f0c8c605f26b768ae85ee03627a6af.jpg";